const map = {
	"./0.0.png": "./src/assets/energy-efficiency/0.0.png",
	"./0.5.png": "./src/assets/energy-efficiency/0.5.png",
	"./1.0.png": "./src/assets/energy-efficiency/1.0.png",
	"./1.5.png": "./src/assets/energy-efficiency/1.5.png",
	"./10.0.png": "./src/assets/energy-efficiency/10.0.png",
	"./2.0.png": "./src/assets/energy-efficiency/2.0.png",
	"./2.5.png": "./src/assets/energy-efficiency/2.5.png",
	"./3.0.png": "./src/assets/energy-efficiency/3.0.png",
	"./3.5.png": "./src/assets/energy-efficiency/3.5.png",
	"./4.0.png": "./src/assets/energy-efficiency/4.0.png",
	"./4.5.png": "./src/assets/energy-efficiency/4.5.png",
	"./5.0.png": "./src/assets/energy-efficiency/5.0.png",
	"./5.5.png": "./src/assets/energy-efficiency/5.5.png",
	"./6.0.png": "./src/assets/energy-efficiency/6.0.png",
	"./6.5.png": "./src/assets/energy-efficiency/6.5.png",
	"./7.0.png": "./src/assets/energy-efficiency/7.0.png",
	"./7.5.png": "./src/assets/energy-efficiency/7.5.png",
	"./8.0.png": "./src/assets/energy-efficiency/8.0.png",
	"./8.5.png": "./src/assets/energy-efficiency/8.5.png",
	"./9.0.png": "./src/assets/energy-efficiency/9.0.png",
	"./9.5.png": "./src/assets/energy-efficiency/9.5.png"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/energy-efficiency sync recursive ^\\.\\/.*$";